import React, { useState } from "react";
import styles from "../styles/jobApplicationStats.module.css";

const WellfoundLogo = () => (
  <svg
    viewBox="0 0 554.9 266.7"
    style={{
      width: "22px",
      height: "auto",
      marginRight: "10px",
      verticalAlign: "middle",
    }}
    aria-label="Wellfound Logo"
  >
    <path
      d="M 80.9,263.6 0,3 H 75.3 L 123,190.4 174.9,3 h 75.5 L 302.3,190.4 350,3 h 75.3 L 343.5,263.6 H 263.3 L 212.7,75.4 161.1,263.6 H 80.9 Z"
      fill="#1a1a1a"
    />
    <circle cx="511.1" cy="222.9" fill="#EC2E3A" r="43.8"></circle>
    <circle cx="511.1" cy="43.8" fill="#EC2E3A" r="43.8"></circle>
  </svg>
);

const HistoryTab = ({
  allApplications,
  totalApplications,
  getJobDisplayTitle,
  formatDate,
}) => {
  const [showAll, setShowAll] = useState(false);

  // Safety Check
  const safeApplications = Array.isArray(allApplications)
    ? allApplications
    : [];

  // Sort: Newest First
  const sortedApplications = [...safeApplications].sort((a, b) => {
    const dateA = a.appliedAt?._seconds
      ? a.appliedAt._seconds
      : new Date(a.appliedAt).getTime();
    const dateB = b.appliedAt?._seconds
      ? b.appliedAt._seconds
      : new Date(b.appliedAt).getTime();
    return dateB - dateA;
  });

  const applicationsToShow = showAll
    ? sortedApplications
    : sortedApplications.slice(0, 5);

  const handleToggleShowAll = () => {
    setShowAll((prevState) => !prevState);
  };

  return (
    <div className={styles.historyContainer}>
      <h3>Recent Job Applications</h3>

      {safeApplications.length === 0 ? (
        <div className={styles.emptyState}>
          <i
            className="fas fa-ghost"
            style={{ fontSize: "2rem", color: "#ccc", marginBottom: "10px" }}
          ></i>
          <p>No job applications yet. Start the automation to apply!</p>
        </div>
      ) : (
        <>
          <div className={styles.applicationList}>
            <div className={styles.listHeader}>
              <span>Role / Company</span>
              <span className={styles.listHeaderDate}>Date Applied</span>
            </div>
            {applicationsToShow.map((job, index) => (
              <div className={styles.applicationItem} key={index}>
                <div
                  className={styles.jobLink}
                  style={{ display: "flex", alignItems: "center" }}
                >
                  {/* CORRECT WELLFOUND SVG LOGO */}
                  <WellfoundLogo />

                  <a
                    href={job.jobUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{
                      fontWeight: "600",
                      color: "#2563eb",
                      textDecoration: "none",
                    }}
                  >
                    {job.jobTitle || "Wellfound Application"}
                  </a>
                </div>
                <div className={styles.applicationDate}>
                  {(() => {
                    try {
                      if (!job.appliedAt) return "Just now";
                      const d = job.appliedAt._seconds
                        ? new Date(job.appliedAt._seconds * 1000)
                        : new Date(job.appliedAt);
                      return d.toLocaleDateString("en-US", {
                        month: "short",
                        day: "numeric",
                      });
                    } catch (e) {
                      return "Recent";
                    }
                  })()}
                </div>
              </div>
            ))}
          </div>

          {totalApplications > 5 && (
            <div className={styles.viewAllContainer}>
              <button
                className={styles.viewAllButton}
                onClick={handleToggleShowAll}
              >
                {showAll
                  ? "Show Less"
                  : `View All Applications (${totalApplications})`}
              </button>
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default HistoryTab;
